// import React from 'react'

import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import * as React from "react";
import { useState } from "react";
import * as yup from "yup";
import CancelPresentationIconButton from "../../../common/components/Buttons/CancelPresentationIconButton";
import CommonButton from "../../../common/components/Buttons/CommonButton";
import CommonBackDrop from "../../../common/components/CommonBackDrop/CommonBackDrop";
import ConfirmationModal from "../../../common/components/ConfirmationModal";
import {
  errorAlert,
  successAlert,
} from "../../../common/components/Toasts/CustomToasts";
import { releaseSecondaryAllocatedBed } from "../../services/bedAllowcationServices/BedAllowcationServices";

export const Schema = yup.object().shape({
  BedCategory: yup
    .object()
    .nullable()
    .shape({
      value: yup.string().required("Please Select Category"),
      label: yup.string().required("Please Select Category"),
    })
    .required("Required"),

  ChargesPerBedCategory: yup
    .object()
    .nullable()
    .shape({
      value: yup.string().required("Please Select Category"),
      label: yup.string().required("Please Select Category"),
    })
    .required("Required"),
});

const ModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { sm: "80%", lg: "50%" },
  // minWidth:"25%",
  // height: "30%",
  bgcolor: "background.paper",
  borderRadius: 2,
  border: "none",
  "&:focus": {
    outline: "none",
  },
};

//

export default function SecondaryBedReleaseModal(props) {
  const {
    open,
    handleClose,
    menuId,
    privilege,
    getBedListData,
    bedDetails,
  } = props;

  const [openBackdrop, setOpenBackdrop] = useState(false);
  //

  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const handleConfirmationClose = () => setOpenConfirmationModal(false);
  //

  const onSubmit = () => {
    setOpenConfirmationModal(true);
  };

  const handleFormSubmit = () => {
    setOpenConfirmationModal(false);
    setOpenBackdrop(true);

    releaseSecondaryAllocatedBed(bedDetails?.BedId, menuId, privilege)
      .then((response) => response.data)
      .then((res) => {
        successAlert(res.message);
        setOpenBackdrop(false);
        handleClose();
        getBedListData();
      })
      .catch((res) => {
        errorAlert(res?.response?.data?.message || res.message);
        setOpenBackdrop(false);
        handleClose();
      });
  };

  return (
    <div>
      <Modal
        open={open}
        // onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={ModalStyle} className="max-h-[88%] xl:max-h-[100%]">
          <CancelPresentationIconButton
            onClick={() => {
              handleClose();
              //   setEdit(false);
              //   reset(defaultValues);
            }}
          />
          <form>
            <div className="mx-3 mb-3 mt-2 items-center align-middle">
              <div className=" p-2 rounded  text-black font-semibold whitespace-nowrap">
                Release Secondary Bed
              </div>

              <hr className="border mx-1  border-blue-900" />

              <div className="grid border border-gray-300 bg-gray-100 px-3 rounded mt-2">
                <div className="grid grid-cols-2  gap-2 py-2">
                  <div className="grid gap-2 border-r-2 border-slate-500 my-1 ">
                    {/* Patient Name , UHID */}
                    <div className="flex gap-2 ">
                      <h1 className="text-black font-semibold flex space-x-1">
                        <span className="text-sm">Patient Name </span>
                        <span className=""> :</span>
                      </h1>

                      <h1 className="font-normal">
                        {bedDetails?.ptInfo &&
                          bedDetails?.ptInfo["Patient Name"]}
                      </h1>
                    </div>
                    {/* Gender */}
                    <div className="flex gap-2 ">
                      <h1 className="text-black font-semibold flex space-x-5 lg:space-x-4">
                        <span className="text-sm">Gender</span>
                        <span className="lg:pl-7 md:pl-6">:</span>
                      </h1>

                      <h1 className="font-normal">
                        {bedDetails?.ptInfo && bedDetails?.ptInfo["Gender"]}
                      </h1>
                    </div>
                    <div className="flex gap-2 items-center">
                      <h1 className="text-black font-semibold flex space-x-1 lg:space-x-1">
                        <span className="text-sm">Allocated Bed No.</span>
                        <span className="lg:pl-0 md:pl-1">:</span>
                      </h1>

                      <h1 className="font-normal">
                        {bedDetails && bedDetails["BedNo"]}
                      </h1>
                    </div>
                  </div>

                  {/* MRNo */}
                  <div className="grid gap-2  pl-4 border-slate-500 my-1 ">
                    <div className="flex gap-2 ">
                      <h1 className="text-black font-semibold flex space-x-16 lg:space-x-16">
                        <span className="text-sm">MRNo</span>
                        <span className="">:</span>
                      </h1>
                      <h1 className="font-normal">
                        {bedDetails?.ptInfo && bedDetails?.ptInfo["MRNo"]}
                      </h1>
                    </div>
                    {/* age */}
                    <div className="flex gap-2 ">
                      <h1 className="text-black font-semibold flex space-x-16 lg:space-x-16">
                        <span className="text-sm">Age</span>
                        <span className="md:pl-4">:</span>
                      </h1>
                      <h1 className="font-normal">
                        {bedDetails?.ptInfo && bedDetails?.ptInfo["Age"]}
                      </h1>
                    </div>

                    <div className="flex gap-2 ">
                      <h1 className="text-black font-semibold flex space-x-0 lg:space-x-1">
                        <span className="text-sm">Allocated Bed Category</span>
                        <span className="">:</span>
                      </h1>
                      <h1 className="font-normal">
                        {bedDetails && bedDetails["BedCategory"]}
                      </h1>
                    </div>
                  </div>
                </div>
              </div>

              <div className=" p-2 rounded  text-black  ">
                Do You Want To Release Secondary Allocated Bed ?
              </div>

              <div className="flex justify-end my-2 gap-3">
                <CommonButton
                  label="Cancel"
                  onClick={() => {
                    handleClose();
                  }}
                  className="border border-customRed text-customRed "
                />
                <CommonButton
                  label="Proceed"
                  onClick={() => {
                    onSubmit();
                  }}
                  className="bg-customGreen text-white "
                />
              </div>
            </div>
          </form>
          {openBackdrop && <CommonBackDrop openBackdrop={openBackdrop} />}

        </Box>
      </Modal>
      {/* //Confirmation Modal// */}
      <ConfirmationModal
        confirmationOpen={openConfirmationModal}
        confirmationHandleClose={handleConfirmationClose}
        confirmationSubmitFunc={() => handleFormSubmit()}
        confirmationLabel="Confirmation "
        confirmationMsg="Are You Sure ?"
        confirmationButtonMsg="Proceed"
      />{" "}
    </div>
  );
}
